import script from "./TwoFactorSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./TwoFactorSetup.vue?vue&type=script&setup=true&lang=js"

import "./TwoFactorSetup.vue?vue&type=style&index=0&id=7cc404a0&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cc404a0"]])

export default __exports__